import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScMobileAppPopup = styled.div`
  display: flex;
  position: fixed;
  inset: 0 0 auto;
  background-color: ${({ theme }) => theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  min-height: 32px;
  padding: 4px 16px;
  z-index: 100;
  width: 100%;
  .button-close {
    svg {
      width: 32px;
      height: 32px;
      path {
        fill: ${({ theme }) => theme.grayColor};
        transition: fill 0.3s;
      }
    }

    &:hover {
      svg {
        path {
          fill: ${({ theme }) => theme.blackColor};
        }
      }
    }
  }

  .wrapper {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    .text {
      display: flex;
      ${typography['body2regular']};
      gap: 4px;
      .title {
        ${typography['body2bold']}
      }
    }
    .wrapper-button-close {
      position: absolute;
      right: 8px;
      width: 32px;
      height: 32px;
    }
    .button {
      padding: 0px 12px;
      .text {
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
      }
    }
    @media (${device.mobileXS}) {
      width: 100%;
      .wrapper-button {
        position: relative;
        margin-left: auto;
      }
      .wrapper-button-close {
        position: relative;
        right: 0;
        width: 32px;
        height: 32px;
      }
      .button {
        margin-right: auto;
      }
      .text {
        flex-direction: column;
        gap: 0;
      }
    }
  }
`;
